<template>
    <v-list-group
            :prepend-icon="nav.icon"
            :value="false"
            color="white"
    >
        <template v-slot:activator>
            <v-list-item-title class="white--text">{{nav.title}}</v-list-item-title>
        </template>
                <NavEntry :sub="true" v-for="nav in navItems" :key="nav.title" :nav="nav"></NavEntry>
    </v-list-group>
</template>
<script>
    import NavEntry from "./NavEntry";
    export default {
        components: {NavEntry},
        props: ['nav', 'sub'],
        computed: {
            navItems: function () {
                if (this.nav.children) {
                    return this.nav.children
                } else {
                    return this.$store.state[this.nav.children_array].map((t) => {
                        return {
                            to: {name: 'mannschaft', params: {team: t.url}},
                            title: t.name,
                            header: t.header,
                            children: t.children
                        }
                    })
                }
            }
        }
    }
</script>
<style scoped>
    .submenu {
        background:#D84315 !important;
    }
</style>